export default {"src":"/_next/static/media/icGiftActive2.01ec4f11.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};